import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgFullPageDialog } from "@intelligems/ig-theme";
import { QuantityButtonsWidgetDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { ColorAndStyle } from "@src/components/ColorAndStyle/ColorAndStyle";
import { GlobalStylesHeader } from "@src/domains/WidgetLibrary/GlobalStylesHeader";
import { offerExample } from "@src/domains/WidgetLibrary/stubs";
import { useWidgetSave } from "@src/domains/WidgetLibrary/useWidgetSave";
import { QuantityButtonsPreview } from "@src/features/personalizations/components/offerModifications/widgets/QuantityButtonsPreview";
import { OfferComponentSettingsPageWrapper } from "@src/features/sharedExperience/components/offers/subpages/OfferComponentSettingsPageWrapper";
import { useViewPage } from "@src/hooks/mixpanel";
import {
  getDialogPropDetails,
  isDialogOpen,
  setDialog,
} from "@src/store/slices/global";
import { selectedWidget } from "@src/store/slices/widgets";

export const QuantityButtonsFullPageDialog = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(isDialogOpen("quantityButtonsFullPageEditor"));
  const dialogProps = useSelector(
    getDialogPropDetails("quantityButtonsFullPageEditor")
  ) as
    | { widgetId?: string; variationId: string; widgetType: "quantityButtons" }
    | undefined;

  const currentWidget = useSelector(selectedWidget) as QuantityButtonsWidgetDto;

  const { save, isSaving } = useWidgetSave(currentWidget);

  const handleClose = () => {
    dispatch(
      setDialog({ dialog: "quantityButtonsFullPageEditor", open: false })
    );
  };

  const handleSave = () => {
    save();
    handleClose();
  };

  const handleCancel = () => {
    handleClose();
  };
  useViewPage("Global Styles - Quantity Buttons Full Page Editor");
  const content =
    dialogProps && currentWidget ? (
      <Grid container width={"100%"} justifyContent={"center"}>
        <Grid container direction={"column"} rowSpacing={4} width={"1250px"}>
          <Grid item>
            <GlobalStylesHeader
              variantStyle={
                currentWidget.config.desktop?.variant ||
                "quantityButtonsWidget1"
              }
              widgetType={"quantityButtons"}
            />
          </Grid>
          <Grid item>
            <OfferComponentSettingsPageWrapper
              variationId={dialogProps.variationId}
              widgetType="quantityButtons"
              hasQuantityButtons={true}
              hasProgressbar={false}
              hasMessageBox={false}
              offerProducts={[]}
              widgetId={dialogProps.widgetId}
              customPreview={
                <QuantityButtonsPreview
                  renderLocation="settings"
                  widget={currentWidget}
                  offer={offerExample}
                  offerProducts={[]}
                />
              }
            />
          </Grid>
        </Grid>
      </Grid>
    ) : null;

  return (
    <IgFullPageDialog
      showDialog={isOpen}
      handleClose={handleClose}
      content={content}
      yesButtonText={isSaving ? "Saving..." : "Save Widget"}
      handleYesClick={handleSave}
      noButtonText="Cancel"
      handleNoClick={handleCancel}
      shouldNotClose={true}
      hideActions={false}
    />
  );
};
